<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <b-form class="form-compra">
          <b-card>
            <b-form>
              <b-form-group
                label="Banco"
                label-for="banco"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="banco" 
                  :value="banco" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Tarjeta"
                label-for="tarjetaMarca"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="tarjetaMarca" 
                  :value="tarjetaMarca"
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Nro.Cuenta"
                label-for="numeroCuenta"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="numeroCuenta" 
                  :value="numeroCuenta" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Fecha de Cierre"
                label-for="fechaCierre"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaCierre" 
                  :value="fechaCierre | fecha" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Fecha de Vencimiento"
                label-for="fechaVencimiento"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaVencimiento" 
                  :value="fechaVencimiento | fecha" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Total"
                    label-for="totalCierrePesos"
                    :label-cols="labelCols * 2"
                    horizontal>
                    <b-form-input 
                      id="totalCierrePesos" 
                      :value="totalCierrePesos | moneda" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
    
                  <b-form-group
                    label="Pagos"
                    label-for="totalPagosPesos"
                    :label-cols="labelCols * 2"
                    horizontal>
                    <b-form-input 
                      id="totalPagosPesos" 
                      :value="totalPagosPesos | moneda" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Total"
                    label-for="totalCierreDolares"
                    :label-cols="labelCols * 2"
                    horizontal>
                    <b-form-input 
                      id="totalCierreDolares" 
                      :value="totalCierreDolares | moneda('USD')" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
    
                  <b-form-group
                    label="Pagos"
                    label-for="totalPagosDolares"
                    :label-cols="labelCols * 2"
                    horizontal>
                    <b-form-input 
                      id="totalPagosDolares" 
                      :value="totalPagosDolares | moneda('USD')" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <app-opcion-pago
                label="Opción Pago"
                :nombre="opcionPagoNombre"
                :lista="opcionesPagoList"
                :labelCols="labelCols"
                :nullDisabled="false"
                labelOption="Seleccione la opción de pago"
                @updated="opcionPagoActualizada">
              </app-opcion-pago>
            </b-form>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>    
  </div>
</template>

<script>
import OpcionPago from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetaResumenPago/getField',
  mutationType: 'tarjetaResumenPago/updateField',
});

export default {
  name: 'TarjetasResumenesPagosOpcionPago',
  components: {
    appOpcionPago: OpcionPago,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      opcionesPago: [],
      opcionesPagoList: [],
      labelCols : 2,
    }
  },
  computed: {
    ...mapFields([
      'tarjetaResumenId',
      'banco',
      'tarjetaMarca',
      'numeroCuenta',
      'fechaCierre',
      'fechaVencimiento',
      'totalCierrePesos',
      'totalPagosPesos',
      'totalCierreDolares',
      'totalPagosDolares',
      'opcionPagoId',
      'opcionPagoNombre'
    ]),
  },
  activated() {
    this.getDatosAdicionales();
    this.validarPagoResumen();
  },  
  methods: {
    validarPagoResumen() {
      this.$emit('can-continue', { value: false });

      if (this.opcionPagoId != 0) {
        this.$emit('can-continue', { value: true });
      }
    },
    getDatosAdicionales() {
        this.opcionesPago = [
            { id: 1, nombre: 'Pagar el Monto en Pesos del Resumen' },
            { id: 2, nombre: 'Pagar el Monto en Dólares del Resumen' },
            { id: 3, nombre: 'Pagar Todo el Resumen en Pesos' },
        ];

        this.opcionesPagoList = this.opcionesPago.map(opcion => opcion.nombre.trim());
    },
    opcionPagoActualizada(opcionPagoNombre) {
      let opcionPago = null;
      if (opcionPagoNombre) {
          opcionPago = this.opcionesPago.find(opcion => opcion.nombre.toUpperCase().trim() === opcionPagoNombre.toUpperCase().trim());
      }
      this.$store.dispatch('tarjetaResumenPago/setOpcionPago', opcionPago)
        .then(() => {
          this.validarPagoResumen();
        });
    },
  },
}
</script>

<style>
</style>
